import React from "react";
import { Factory, Landmark, LineChart, Network } from "lucide-react";

const AUDIENCES = [
  {
    icon: <Factory size={24} />,
    segment: "MSMEs",
    headline: "Understand your carbon footprint",
    desc:
      "Get a structured carbon intensity estimate using your existing GST purchase data. No consultants, no primary data collection, no lengthy process.",
    benefits: [
      "Access sustainability-linked finance",
      "Qualify for green supply chain programmes",
      "Benchmark against sector peers",
    ],
  },
  {
    icon: <Landmark size={24} />,
    segment: "Banks & NBFCs",
    headline: "Screen your lending portfolio",
    desc:
      "Assess climate-related financial risk across your MSME borrower base. Integrate carbon screening into credit appraisal and ESG disclosure workflows.",
    benefits: [
      "RBI ESG framework readiness",
      "Portfolio-level carbon risk mapping",
      "Regulatory disclosure support",
    ],
  },
  {
    icon: <LineChart size={24} />,
    segment: "ESG Analysts",
    headline: "Rapid Scope 3 proxy estimates",
    desc:
      "Generate credible spend-based Scope 3 Category 1 estimates for portfolio companies and supply chain entities — without full primary data campaigns.",
    benefits: [
      "GHG Protocol Scope 3 alignment",
      "PCAF standard compatibility",
      "Audit-ready screening trail",
    ],
  },
  {
    icon: <Network size={24} />,
    segment: "Supply Chain Teams",
    headline: "Map carbon risk across your supply base",
    desc:
      "Identify high-carbon-exposure suppliers and prioritise engagement. Use screening outputs to inform supplier development and transition planning.",
    benefits: [
      "Supplier carbon risk tiering",
      "EU CSRD supply chain readiness",
      "Prioritise decarbonisation spend",
    ],
  },
];

export default function AudienceSection() {
  return (
    <section className="audience-section" id="audience">
      <div className="landing-container">
        <div className="section-label">WHO IT'S FOR</div>
        <h2 className="section-title">
          Built for Every Stakeholder in the Carbon Risk Chain
        </h2>
        <p className="section-sub">
          GreenSetu serves the full ecosystem — from the MSME being assessed
          to the financial institution making lending decisions.
        </p>

        <div className="audience-grid">
          {AUDIENCES.map((a, i) => (
            <div key={i} className="audience-card">
              <div className="audience-card-icon">{a.icon}</div>
              <div className="audience-segment">{a.segment}</div>
              <h3 className="audience-headline">{a.headline}</h3>
              <p className="audience-desc">{a.desc}</p>
              <ul className="audience-benefits">
                {a.benefits.map((b, j) => (
                  <li key={j}>
                    <span className="audience-check">✓</span>
                    {b}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
